import { createAction, createReducer, on, props } from '@ngrx/store';

import { UserPrefs } from '../api/UserPrefs-dto';

export const SET_USERPREFS_TYPE = 'SET_USERPREFS';
export const SET_USERPREFS = createAction(SET_USERPREFS_TYPE, props<{ userPrefs: UserPrefs, avoidPersistence?: boolean }>());
export const DELETE_USERPREFS = createAction('DELETE_USERPREFS', props<{ avoidPersistence?: boolean }>());
export const CLEAR_ENSALERTVIEWSTATE = createAction('CLEAR_ENSALERTVIEWSTATE', props<{ avoidPersistence?: boolean }>());

const initialState = undefined;

const _userPrefsReducer = createReducer(
  initialState,
  on(SET_USERPREFS, (state, { userPrefs }) => userPrefs),
  on(DELETE_USERPREFS, () => initialState),
  on(CLEAR_ENSALERTVIEWSTATE, (state) => {
    if (state) {
      state.mainViewPrefs.ENSAlertViewed = false;
    }
    return state;
  })
);

export function userPrefsReducer(state, action) {
  return _userPrefsReducer(state, action);
}
